import {
    collection,
    addDoc,
    serverTimestamp,
    query,
    orderBy,
    limit,
    getDocs
} from 'firebase/firestore';
import { db } from '../firebase';

// Activity types
export const ACTIVITY_TYPES = {
    // Customer actions
    CUSTOMER_DELETED: 'customer_deleted',
    CUSTOMER_VIEWED: 'customer_viewed',

    // Servicemen actions
    SERVICEMAN_DELETED: 'serviceman_deleted',
    SERVICEMAN_UPDATED: 'serviceman_updated',
    SERVICEMAN_VIEWED: 'serviceman_viewed',
    SERVICEMAN_APPROVED: 'serviceman_approved',
    SERVICEMAN_REJECTED: 'serviceman_rejected',
    SERVICEMAN_REVIEWED: 'serviceman_reviewed',

    // User management actions
    USER_CREATED: 'user_created',
    USER_UPDATED: 'user_updated',
    USER_DELETED: 'user_deleted',
    USER_PASSWORD_CHANGED: 'user_password_changed',

    // System actions
    LOGIN: 'login',
    LOGOUT: 'logout'
};

// Activity severity levels
export const SEVERITY_LEVELS = {
    LOW: 'low',        // View actions
    MEDIUM: 'medium',  // Update/Approve actions
    HIGH: 'high'       // Delete actions
};

// Log activity to Firebase
export const logActivity = async (activityData) => {
    try {
        const logEntry = {
            ...activityData,
            timestamp: serverTimestamp(),
            createdAt: new Date().toISOString()
        };

        const docRef = await addDoc(collection(db, 'logs'), logEntry);

        return {
            success: true,
            logId: docRef.id
        };
    } catch (error) {
        console.error('Error logging activity:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

// Get activity logs
export const getActivityLogs = async (limitCount = 50) => {
    try {
        const logsQuery = query(
            collection(db, 'logs'),
            orderBy('timestamp', 'desc'),
            limit(limitCount)
        );

        const logsSnapshot = await getDocs(logsQuery);
        const logs = [];

        logsSnapshot.forEach(doc => {
            const data = doc.data();
            logs.push({
                id: doc.id,
                ...data,
                timestamp: data.timestamp?.toDate?.()?.toLocaleString() || data.createdAt
            });
        });

        return {
            success: true,
            logs
        };
    } catch (error) {
        console.error('Error fetching activity logs:', error);
        return {
            success: false,
            error: error.message,
            logs: []
        };
    }
};

// Helper function to create activity data
export const createActivityData = (user, activityType, details, severity = SEVERITY_LEVELS.MEDIUM) => {
    return {
        userId: user.id,
        username: user.username,
        userRole: user.role,
        userName: user.name || user.username,
        activityType,
        details,
        severity,
        ipAddress: 'N/A', // Could be enhanced to get real IP
        userAgent: navigator.userAgent
    };
};
